





































import Vue, { PropOptions } from 'vue';
import dayjs from 'dayjs';
import { Campaign } from '@/models';

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
    teams: Array,
  },
  data() {
    const dayjsDate = this.campaign.scheduledTo ?
      dayjs(this.campaign.scheduledTo.iso) : dayjs();
    return {
      rules: {
        required: [(v: any) => v !== undefined || 'Campo obrigatório'],
      },
      radios: false,
      routeReplies: !!this.campaign.routeReplies,
      durationOptions: [{
        label: '1 dia',
        value: 1,
      }, {
        label: '2 dias',
        value: 2,
      }, {
        label: '3 dias',
        value: 3,
      }],
      teamsOptions: this.teams && this.teams.map((team: any) => ({
        label: team.name, value: team.objectId,
      })),
    };
  },
  watch: {
    routeReplies(val) {
      if (val) {
        this.$emit('update', { routeReplies: {
          to: 'TEAM',
          untilDate: 1,
        }});
      } else {
        this.$emit('update', { routeReplies: null});
      }
    },
    teams(val) {
      this.teamsOptions = val && val.map((team: any) => ({
        label: team.name, value: team.objectId,
      }));
    },
  },
});
